module.exports = __webpack_public_path__ + "static/media/project-img1.d0846ff7.png";